import React from 'react';
import styled from 'styled-components/macro';

import { Divider, Typography } from '@mui/material';

import SidebarNavList from './SidebarNavList';
import { NavItemOption } from './types';

const Title = styled(Typography)`
  color: #94a3b8;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  padding: ${(props) => props.theme.spacing(1.75)}
    ${(props) => props.theme.spacing(1.5)}
    ${(props) => props.theme.spacing(0.5)};
  text-transform: uppercase;
  display: block;
`;

const SidebarNavSection = (props: {
  key: string;
  title: string;
  pages: NavItemOption[];
  component?: 'nav';
  collapsed?: boolean;
  isFirst?: boolean;
}) => {
  const {
    title,
    pages,
    collapsed = false,
    isFirst = false,
    component: Component = 'nav',
    ...rest
  } = props;

  return (
    <Component {...rest}>
      {collapsed && !isFirst && (
        <Divider
          sx={{
            my: 1.25,
            mx: 0.5,
            borderColor: 'rgba(148, 163, 184, 0.28)',
          }}
        />
      )}
      {!collapsed && title && <Title variant="subtitle2">{title}</Title>}
      <SidebarNavList pages={pages} depth={0} collapsed={collapsed} />
    </Component>
  );
};

export default SidebarNavSection;
